// start:ng42.barrel
export * from './brand-logo.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/brand-logo/index.ts